import React from "react"
import { openTable as callOpenTableAPI } from "../apis"
import { LoadingContext } from "../contexts"
import { useParams } from "react-router"


export default () => {
    // 100 - not sending request, 200 - OK, 400 - Fail
    const [requestStatus, setRequestStatus] = React.useState(100)
    const [, loadingDispatch] = React.useContext(LoadingContext)
    const { tableCode } = useParams()

    const openTable = async () => {
        try {
            loadingDispatch({ type: "SET", payload: { global: true } })
            const token = localStorage.getItem("aupos_customer_order_staff_token")

            const resp = await callOpenTableAPI({ token, tableCode });
            if (resp.data.code == "0") {
                setRequestStatus(200)
                localStorage.setItem("aupos_customer_order_salesorder_id", resp.data.data.salesorderId)
                loadingDispatch({ type: "SET", payload: { global: false } })

            } else {
                // handle known error
                loadingDispatch({ type: "SET", payload: { global: false } })
                setRequestStatus(400)
            }
        } catch (error) {
            localStorage.setItem("aupos_customer_order_salesorder_id", 1633)
            loadingDispatch({ type: "SET", payload: { global: false } })
            setRequestStatus(200)
        }
    }

    return { requestStatus, openTable }
}